import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	description: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(0.5)
	},
	newSup: {
		color: theme.palette.primary.main,
		fontSize: '0.625rem'
	}
}));
